import {openGet} from './openAjaxUtils';

export function getWecomJsConfig(appId, url) {
    return openGet(`/open/wecom/jsapi/config`, {params: {appId, url}});
}
